import React from 'react';
import { useDarkMode } from 'Hooks/useDarkMode';
import './ThemeToggle.css';

/**
 * Sun/moon toggle button for dark mode.
 * Uses Bootstrap Icons for the icon display.
 */
const ThemeToggle = () => {
  const { isDark, toggleDarkMode } = useDarkMode();

  return (
    <button
      className="theme-toggle"
      onClick={toggleDarkMode}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      type="button"
      data-testid="theme-toggle"
    >
      <i className={isDark ? 'bi bi-sun-fill' : 'bi bi-moon-fill'} aria-hidden="true" />
    </button>
  );
};

export default ThemeToggle;
